import {
	Avatar,
	Box,
	Button,
	Flex,
	Icon,
	Popover,
	PopoverArrow,
	PopoverBody,
	PopoverContent,
	PopoverTrigger,
	Portal,
	Text,
	useDisclosure
} from "@chakra-ui/react";
import { RiListUnordered, RiShutDownLine, RiUserLine } from "react-icons/ri";
import { useHistory } from "react-router-dom";

import { useAuth } from "../../hooks/auth";

const PopoverUser: React.FC = () => {
	const { user, signOut } = useAuth();
	const history = useHistory();

	const { onToggle } = useDisclosure();

	return (
		<Box>
			<Popover>
				{/* BOTÃO AVATAR */}
				<PopoverTrigger>
					<Button
						w={["6", "8"]}
						p="0"
						ml="0"
						bg="transparent"
						border="none"
						_hover={{
							bg: "transparent",
						}}
						_focus={{
							border: 'none',
							bg: "transparent",
						}}
						onClick={() => onToggle()}
					>
						<Avatar size={["sm", "md"]} name={user.nome} src={user.url_avatar} />
					</Button>
				</PopoverTrigger>

				<Portal>
					<PopoverContent
						w="auto"
						p="2"
						mt={-2}
						mr="4"
						boxShadow="2px 3px 3px 3px rgba(0, 0, 0, 0.2)"
						border="none"
						_focus={{
							border: 'none',
						}}
					>
						<PopoverArrow />

						{/* USUÁRIO */}
						<PopoverBody
							// boxShadow="2px 3px 3px 3px rgba(0, 0, 0, 0.2)"
							borderRadius={8}
							mb="2"
						>
							<Flex ml="1" align="end" flexDir="column">
								<Text ml="6" fontSize="18" fontWeight="500">{user.nome}</Text>
								<Text ml="6" fontSize="16" fontWeight="500" color="gray.500">{user.email}</Text>
							</Flex>
						</PopoverBody>

						<Box borderTopWidth={1} borderTopColor="gray.50" />

						{/* PEDIDOS */}
						<Button
							variant="unstyled"
							fontWeight="400"
							pl="2"
							onClick={() => history.push('/sales')}
							_hover={{
								fontWeight: '500',
								color: 'blue.100',
								svg: { color: 'blue.100', fontSize: '21' }
							}}
						>
							<Flex ml="1" align="center">
								<Icon as={RiListUnordered} fontSize="20" color="gray.500" />
								<Text ml="6" fontSize="18">Pedidos</Text>
							</Flex>
						</Button>

						<Box borderTopWidth={1} borderTopColor="gray.50" />

						{/* PERFIL */}
						<Button
							variant="unstyled"
							isDisabled
							fontWeight="400"
							pl="2"
							_hover={{
								fontWeight: '500',
								color: 'blue.100',
								svg: { color: 'blue.100', fontSize: '21' }
							}}
						>
							<Flex ml="1" align="center">
								<Icon as={RiUserLine} fontSize="20" color="gray.500" />
								<Text ml="6" fontSize="18">Perfil</Text>
							</Flex>
						</Button>

						<Box borderTopWidth={1} borderTopColor="gray.50" />

						{/* SAIR */}
						<Button
							variant="unstyled"
							fontWeight="400"
							pl="2"
							_hover={{
								fontWeight: '500',
								color: 'blue.100',
								svg: { color: 'blue.100', fontSize: '21' }
							}}
						>
							<Flex
								ml="1"
								align="center"
								onClick={() => signOut()}
							>
								<Icon as={RiShutDownLine} fontSize="20" color="gray.500" />
								<Text ml="6" fontSize="18">Sair</Text>
							</Flex>
						</Button>
					</PopoverContent>
				</Portal>
			</Popover>
		</Box>
	)
}

export default PopoverUser;
